import { RootState, useDispatch, useSelector } from '../../../store'
import { CloudMarketplace } from '../../../modules/productsListing/types'
import {
  getProductInfoDetail,
  getProducts,
} from '../../../modules/productsListing/action'
import { useEffect, useMemo } from 'react'
import { isEmpty } from 'lodash'

export const useGetProductDetail = ({
  accountId,
  productId,
  cloudMarketplace,
}: {
  accountId: string
  productId: string
  cloudMarketplace: CloudMarketplace
}) => {
  const dispatch = useDispatch()
  const productsListingState = useSelector(
    (state: RootState) =>
      state.productsListing[cloudMarketplace]?.products?.rows
  )

  const hasProducts = !isEmpty(productsListingState)

  const productDetail = useSelector(
    (state: RootState) =>
      state.productsListing?.[cloudMarketplace]?.productDetail ?? undefined
  )

  const products = useSelector(
    (state: RootState) =>
      state.productsListing?.[cloudMarketplace]?.products?.rows ?? []
  )

  const selectedProduct = useMemo(() => {
    return (
      products.find(product => product.productId === productId) ?? undefined
    )
  }, [products, productId])

  const matchedProductDetail =
    productDetail?.productId === productId ? productDetail : undefined

  useEffect(() => {
    const fetchProductDetail = async () => {
      dispatch(getProductInfoDetail({ accountId, cloudMarketplace, productId }))
    }
    if (!matchedProductDetail && cloudMarketplace === 'AWS' && !hasProducts) {
      fetchProductDetail()
    }
  }, [cloudMarketplace, accountId, productId, productDetail, hasProducts])

  useEffect(() => {
    if (cloudMarketplace !== 'AWS' && !hasProducts) {
      dispatch(getProducts(accountId, cloudMarketplace))
    }
  }, [accountId, cloudMarketplace, hasProducts])

  return matchedProductDetail || selectedProduct
}
